import React from 'react';
import { Users, TrendingUp, Handshake } from 'lucide-react';
import VisitBookingPage from '../components/VisitBookingPage';

// Swap these for the real client experience videos (YouTube/Vimeo embed URLs).
const ONSITE_VIDEO_1 = '';
const ONSITE_VIDEO_2 = '';

const BookOnSite = () => (
  <VisitBookingPage
    type="onsite"
    accent="green"
    title="On-Site Visit"
    subtitle="2-Day Deep Dive into Your Business at your office or a local Airbnb"
    overviewTitle="What to Expect"
    overviewCards={[
      {
        icon: Users,
        title: 'Expert Team',
        text: 'Our team analyzes every aspect of your business on the ground.',
      },
      {
        icon: TrendingUp,
        title: 'Detailed Analysis',
        text: 'A deep dive into operations, finances, and all departments.',
      },
      {
        icon: Handshake,
        title: 'Actionable Results',
        text: 'Leave with a detailed action plan and specific recommendations.',
      },
    ]}
    videos={[
      { url: ONSITE_VIDEO_1, caption: 'A client during their on-site visit' },
      { url: ONSITE_VIDEO_2, caption: 'The 2-day deep dive in action' },
    ]}
  />
);

export default BookOnSite;
